module.exports = __webpack_public_path__ + "static/img/base_four.145b4a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base_four.png
// module id = A7BH
// module chunks = 1